import OnboardingModal from './OnboardingModal';

export default OnboardingModal;
